<template>
  <v-layout column>
    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      title="Information"
    >
      <template #toolbar>
        <v-btn
          small
          class="ml-4"
          color="success"
          @click="openLocationEditorDialog()"
        >
          Create location
        </v-btn>
      </template>
      <vbt-table
        :headers="headers"
        :items="locations"
        :page-size="20"
        searchable
        show-paginator
      />
    </vbt-content-box>

    <ums-location-editor
      v-model="locationEditorDialog"
      :creator="isCreateLocation"
      :item="editableLocation"
      @success="$_fetchData"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useEditorWithDialog, useDataLoading } from '@mixins/factories';

import {
  namespace as LocationsNamespace,
  ActionTypes as LocationsActionTypes,
} from '../store.types';

import UmsLocationEditor from '../_components/UmsLocationEditor.vue';

const dataLoadingOptions = {
  getterName: LocationsActionTypes.GET_LOCATIONS,
  contentName: 'locations',
  searchable: false,
  paged: false,
};
const editorDialogOptions = {
  editorDialogFlagName: 'locationEditorDialog',
  openTriggerName: 'openLocationEditorDialog',
  editorModeFlagName: 'isCreateLocation',
  editableItemName: 'editableLocation',
};

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Route', value: 'route' },
]);

export default {
  name: 'UmsLocations',
  components: {
    UmsLocationEditor,
  },
  mixins: [
    useDataLoading(dataLoadingOptions),
    useEditorWithDialog(editorDialogOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(LocationsNamespace, ['locations']),
  },
  methods: {
    ...mapActions(LocationsNamespace, [LocationsActionTypes.GET_LOCATIONS]),
  },
};
</script>
